import React from 'react';

const TestimonialsSection: React.FC = () => {
  return (
    <section className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-primary mb-4">What Our Customers Say</h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="flex items-center mb-4">
              <span className="text-3xl mr-3">👨‍💼</span>
              <div className="text-yellow-400">★★★★★</div>
            </div>
            <p className="text-gray-700 mb-4 italic">
              "The installation was flawless and the pergola has been perfect through two harsh Ontario winters. 
              The motorized louvers are a game-changer for our family gatherings."
            </p>
            <p className="text-primary font-semibold">— Michael & Sarah C., Mississauga, ON</p>
          </div>
          
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="flex items-center mb-4">
              <span className="text-3xl mr-3">👩‍🦳</span>
              <div className="text-yellow-400">★★★★★</div>
            </div>
            <p className="text-gray-700 mb-4 italic">
              "Professional service from start to finish. The awning has transformed our deck into a usable space 
              even during summer heat waves. Highly recommend!"
            </p>
            <p className="text-primary font-semibold">— Linda M., Burlington, ON</p>
          </div>
          
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="flex items-center mb-4">
              <span className="text-3xl mr-3">👨‍👩‍👧‍👦</span>
              <div className="text-yellow-400">★★★★★</div>
            </div>
            <p className="text-gray-700 mb-4 italic">
              "Amazing quality and the team was incredibly professional. Our pergola looks stunning and 
              has become the centerpiece of our backyard entertaining."
            </p>
            <p className="text-primary font-semibold">— The Johnson Family, Oakville, ON</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
